import {Route, RouterModule}            from '@angular/router';
import {PageMode}                       from '../ap-interface';
import {NgModule}                       from '@angular/core';
import {ApTranslationsComponent}        from './components/translations/ap-translations.component';
import {ApFormStyleComponent}           from './components/form-style/ap-form-style.component';
import {ApGridStyleComponent}           from './components/grid-style/ap-grid-style.component';
import {ApPermissionGuard}              from '../guards/ap-permission-guard.service';
import {ApJobsComponent}                from './components/jobs/ap-jobs.component';
import {ApParameterDefinitionComponent} from './components/parameter/ap-parameter-definition.component';
import {ApTraceLogComponent}            from './components/tracelog/ap-trace-log.component';
import {ApActiveUsersComponent}         from './components/active-users/ap-active-users.component';
import {ApPageNotFoundComponent}        from '../layout/components/ap-page-not-found.component';

const routes: Route[] = [
  {
    path: 'trace-log',
    component: ApTraceLogComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    }
  },
  {
    path: 'parameter-definition',
    component: ApParameterDefinitionComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    }
  },
  {
    path: 'translations',
    component: ApTranslationsComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    }
  },
  {
    path: 'kriging',
    component: ApPageNotFoundComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN,
    }
  },
  {
    path: 'jobs',
    component: ApJobsComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN,
    }
  },
  {
    path: 'form-style',
    component: ApFormStyleComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN,
    }
  },
  {
    path: 'grid-style',
    component: ApGridStyleComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN,
    }
  },
  {
    path: 'active-users',
    component: ApActiveUsersComponent,
    canActivate: [ApPermissionGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN,
    }
  },
  {
    path: 'reports',
    loadChildren: () => import('../ap-reports/ap-reports.module').then(m => m.ApReportsModule),
    data: {
      login: true,
      layout: PageMode.HALFSCREEN
    }
    /*component: ApReportsOverviewComponent,
    canActivate: [ApDeveloperGuard],
    canLoad: [ApDeveloperGuard],
    data: {
      login: true,
      layout: PageMode.HALFSCREEN,
      canActivate: [ApDeveloperGuard],
      canLoad: [ApDeveloperGuard]
    }*/
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [RouterModule]
})
export class ApAdministrationRoutes {
}
